import React, { Component } from 'react';
import axios from 'axios';
import moment from 'moment';
import 'moment/locale/pt';

import InsightcareLocalFooter from './components/InsightcareLocalFooter';
import PdfCentroCirurgico from './components/PdfCentroCirurgico';
import InsightcareHeader from './components/InsightcareHeader';
import ProgressBar from './components/Progress';
import Loading from './components/Loading';

import AuxRoutines from './AuxRoutines';
import Select from 'react-select';
import { BACKEND_URL } from './config/constants';

class PainelCentroCirurgico extends Component {

  constructor(props) {
    super(props);
    const { match: { params } } = this.props;
    this.state = {
      cycle: 0,
      loading: true,
      totalCycles: 0,
      pacientes: [],
      serachPacientes: [],
      filteredPacientes: [],
      numberOfElements: 0,
      base: params.base,
      company: params.company,
      theme: (params.theme === 'dark' ? 'dark' : 'light'),
      iconText: (params.theme === 'dark' ? '_dark' : ''),
      locationName: AuxRoutines.getLocationName(params.base, params.company),
      boolFoward: 1,
      boolPause: 0,
      interval: 0,
      intervalValue: 0,
      value: 0,
      test: '',

    };
    this.loadRequiredData = this.loadRequiredData.bind(this)
  }

  componentDidMount() {
    //Carrega o local se existe
    setTimeout(() => {
      this.setState({ loading: false });
    }, 1000);
    if (this.state.theme === 'dark') {
      document.body.style.backgroundColor = "black";
    }
    this.moveProgress();
    this.loadRequiredData().then(() => {
      this.setState({ appIsReady: true });
    });
  }

  async loadingBar(time) {
    return await new Promise(resolve => {
      this.setState({
        intervalValue: setInterval(async () => {
          resolve('load');
          const newValue = this.state.value + 1;
          if (newValue <= 100 && this.state.boolPause === 0 && this.state.filteredPacientes.length !== 1) {
            this.setState({
              value: newValue,
            });
          }
        }, time),
      });
    });
  }

  moveProgress() {
    clearInterval(this.state.interval);
    clearInterval(this.state.intervalValue);
    if (this.state.boolPause === 0) {
      this.loadingBar(100).then(() => { console.log('loading') });
      this.setState({
        interval: setInterval(async () => {
          this.setState({
            value: 0,
          });
          this.loadRequiredData();
        }, 10000),
      });
    }
  }

  pauseProgress() {
    clearInterval(this.state.intervalValue);
    clearInterval(this.state.interval);
  }

  async loadRequiredData() {
    let sliceSize = 8;

    moment.locale('pt');
    if (this.state.cycle === this.state.totalCycles) {
      let currentDateHour = moment().format('HH:mm, [dia] D [de] MMMM [de] YYYY');
      let pacientes = await this.requestData();
      let numberOfElements = pacientes.length;
      let cycle = 1;
      let totalCycles = Math.ceil(numberOfElements / sliceSize);
      if (totalCycles === 0) {
        cycle = 0;
      }

      this.setState(
        {
          currentDateHour: currentDateHour,
          dashboardData: pacientes,
          pacientes: pacientes.slice(0, sliceSize),
          numberOfElements: numberOfElements,
          cycle: cycle,
          totalCycles: totalCycles
        }
      );
    } else {
      if (this.state.totalCycles > 0) {
        this.setState({ 
          cycle: this.state.cycle + 1, 
          pacientes: this.state.dashboardData.slice(0 + (sliceSize * this.state.cycle), sliceSize + (sliceSize * this.state.cycle)) 
        })
      }
    }
  }

  changeCycle(boolFoward) {
    let sliceSize = 8;
    if (boolFoward === 0) {
      if (this.state.cycle === 1) {
        this.setState({ cycle: this.state.totalCycles, pacientes: this.state.dashboardData.slice(0 + (sliceSize * (this.state.totalCycles - 1)), sliceSize + (sliceSize * (this.state.totalCycles - 1))) })
      } else {
        this.setState({ cycle: this.state.cycle - 1, pacientes: this.state.dashboardData.slice(0 + (sliceSize * (this.state.cycle - 2)), sliceSize + (sliceSize * (this.state.cycle - 2))) })
      }
    } else if (boolFoward === 1) {
      this.loadRequiredData();
    }
    this.setState({
      value: 0,
    });
  }

	actionPause(boolPause) {
		if (boolPause === 0) {
			this.setState({ boolPause: 1 }, () => {
				this.pauseProgress();
			});
		}
		if (boolPause === 1) {
			this.setState({ boolPause: 0 }, () => {
				this.moveProgress();
			});
		}
	}

  async requestData() {
    let returnData = this.state.pacientes; //In case request fails
    //console.log(this.state.base)
    let url = BACKEND_URL + '/command-center/painel-centro-cirurgico?base=' + this.state.base;
    if (this.state.company !== undefined && this.state.company !== 'all') {
      url = url + '&company=' + this.state.company;
    }
    let response = await axios.get(url);
    if (response.data && response.data.Status === true) {
      returnData = response.data.ResponseData;
    }

    this.setState({
      serachPacientes: returnData,
      filteredPacientes: this.state.filteredPacientes.length !== 0 ? this.state.filteredPacientes : returnData,
    });

    return returnData;
  }

  textoGrupoPacientes(ciclo, totalCiclos, totalElementos) {
    if (this.state.filteredPacientes.length === 1) {
      return "Mostrando de 1 a 1, de 1 paciente";
    }
    else {
      var de = (ciclo <= 1) ? ciclo : (ciclo - 1) * 8;
      var ate = (ciclo === totalCiclos) ? totalElementos : ciclo * 8;
      return "Mostrando de " + de + " a " + ate + ", de " + totalElementos + " pacientes";
    }

  }

  changeTheme() {
    this.setState({ loading: true });
    this.setState(prevState => ({
      theme: prevState.theme === 'light' ? 'dark' : 'light',
    }));

    var $path = '/painel/centro-cirurgico/' + this.state.base + '/' + this.state.company;

    if (this.state.theme === 'light') {
      $path = $path + '/dark';
    }
    window.location.href = $path;
    setTimeout(() => {
      this.setState({ loading: false });
    }, 500);
  }

  render() {
    const loading = this.state.loading;
    const theme = this.state.theme;
    return (
      <div className={"App " + theme}>
        {
          loading
            ? (<Loading />)
            : (
              <div>
                <InsightcareHeader title="Mapa Cirúrgico" theme={theme} />
                <main className={"content " + theme} id="panel1Styled">
                  <ProgressBar value={this.state.value} max={100} theme={theme}/>
                  <div className={"inforow " + theme}>
                    <div className={'inforow right ' + theme}>
                      <button className={'buttonIcon ' + theme} onClick={() => this.changeCycle(0)}><img src={"/img/icon_arrow_left" + this.state.iconText + ".svg"} alt="" /></button>
                      <button className={'buttonIcon ' + theme} onClick={() => this.changeCycle(1)}><img src={"/img/icon_arrow_right" + this.state.iconText + ".svg"} alt="" /></button>
                      <button className={'buttonIcon ' + theme} onClick={() => this.actionPause(this.state.boolPause)} ><img src={(this.state.boolPause === 1 ? "/img/icon_play" : "/img/icon_pause") + this.state.iconText + ".svg"} alt=""/></button>
                      <div className='infoText'>{this.textoGrupoPacientes(this.state.cycle, this.state.totalCycles, this.state.numberOfElements)}</div>
                    </div>

                    <div className={'inforow left ' + theme}>
                      <div className='infoText'>Agora são {this.state.currentDateHour}</div>
                      <PdfCentroCirurgico title={"Mapa Cirurgico"} list={(this.state.filteredPacientes.length === 0) ? this.state.serachPacientes : this.state.filteredPacientes} theme={theme} />
                      <form>
                        <div className={'buttonSearch ' + theme}>
                          <img src={"/img/icon_search" + this.state.iconText + ".svg"} alt="" />
                          <Select className={'selectSearch ' + theme}
                            placeholder="Busque por um paciente ou cirurgia..."
                            options={
                              this.state.serachPacientes.map(opt => ({
                                key: opt.CD_AVISO_CIRURGIA + "-" + opt.CD_CIRURGIA_AVISO,
                                label: opt.NM_PACIENTE + " \n(" + opt.DS_CIRURGIA.toLowerCase() + ")",
                                value: opt.CD_AVISO_CIRURGIA + "-" + opt.CD_CIRURGIA_AVISO,
                                nome: opt.NM_PACIENTE,
                                cirurgia: opt.DS_CIRURGIA,
                              }))}
                            onFocus={opt => {
                              this.actionPause(0);
                            }}
                            onBlur={opt => {
                              this.actionPause(1);
                            }}
                            isClearable={true}
                            onChange={opt => {
                              if (opt !== null && opt !== '') {
                                const pessoa = this.state.serachPacientes.find((elem) => (elem.NM_PACIENTE === opt.nome && elem.DS_CIRURGIA === opt.cirurgia));
                                if (pessoa) {
                                  this.setState({
                                    filteredPacientes: [pessoa]
                                  });
                                } else {
                                  this.setState({
                                    filteredPacientes: this.state.serachPacientes,
                                  });
                                }
                              } else {
                                this.setState({
                                  filteredPacientes: this.state.serachPacientes,
                                });
                              }
                            }}
                          />
                        </div>
                      </form>
                      <button className={'buttonIcon ' + theme} onClick={() => this.changeTheme()}><img src={"/img/icon_theme" + this.state.iconText + ".svg"} alt=""/></button>

                    </div>
                  </div>
                  <table className={'table table-striped' + (theme === 'dark' ? '-dark' : '')}>
                    <thead>
                      <tr>
                        <th>Status</th>
                        <th>Sala</th>
                        <th>Paciente</th>
                        <th>Cirurgião</th>
                        <th>Cirurgia </th>
                        <th>Previsão</th>
                      </tr>
                    </thead>
                    <tbody className={theme}>
                      {
                        (this.state.filteredPacientes.length === 1
                          ? this.state.filteredPacientes
                          : this.state.pacientes)
                          .map((data) => {
                            let color = '';
                            let statusClass = "ready";
                            let situacao = data.SITUACAO;
                            let tdClassFarm = "";
                            let spanClassFarm = "";
														let name = data.NM_PACIENTE;
														if (BACKEND_URL.includes('gruposanta')) {
															name = data.NM_PACIENTE.split(' ').slice(-1).join(' ') + ', ' + data.NM_PACIENTE.split(' ')[0].slice(0, 1);
														}
                            let cirurgiao = data.CIRURGIAO.split(' ')[0] + ' ' + data.CIRURGIAO.split(' ').slice(-1).join(' ');
                            let horario = data.HR_INICIO;
                            let cirurgia = data.CD_AVISO_CIRURGIA;
                            cirurgia = cirurgia + ' - ' + data.DS_CIRURGIA;
                            let key = "tr-" + data.CD_AVISO_CIRURGIA+"-"+data.CD_CIRURGIA_AVISO;

                            if (data.SITUACAO === 'Agendada') {
                              statusClass = 'scheduled';
															if (data.PROGRESSO != null && data.PROGRESSO.length > 1) {
																statusClass = 'progress';
																situacao = data.PROGRESSO;
															}
                            } else if (data.SITUACAO === 'Realizada') {
                              statusClass = "ready";
                            } else if (data.SITUACAO === 'Em Cirurgia') {
                              statusClass = 'waiting';
                            } else if (data.SITUACAO === 'Cancelada') {
                              statusClass = 'canceled';
                            } else {
                              statusClass = "progress";
                              if (data.PROGRESSO != null && data.PROGRESSO.length > 1) {
                                statusClass = 'progress';
                                situacao = data.PROGRESSO;
                              }
                            }

                            if (data.PREVISAO != null && data.PREVISAO.length > 1) {
                              horario = horario + ' às ' + data.PREVISAO;
                            }

                            return (
                              <tr key={key} className={statusClass}>
                                {/* <td><div className="alert-label"></div></td> */}
                                <td style={{ overflow: 'hidden', whiteSpace: 'nowrap', color: color }} align="left" className='alert-content'> <div className="alert-label" /> <b>{situacao}</b></td>
                                <td style={{ color: color }} align="left">{data.SALA}</td>
                                <td style={{ overflow: 'hidden', whiteSpace: 'nowrap', color: color }} align="left" className='infoText'><b>{name}</b> | {data.DT_NASCIMENTO} </td>
                                <td style={{ overflow: 'hidden', whiteSpace: 'nowrap', color: color }} align="left">{cirurgiao}</td>
                                <td style={{ overflow: 'hidden', whiteSpace: 'nowrap' }} align="left">{cirurgia.slice(0, 50)}</td>
                                <td className={tdClassFarm} align="left"><span className={spanClassFarm}></span>{horario}</td>
                              </tr>
                            )
                          })
                      }

                    </tbody>
                  </table>
                </main>

                <InsightcareLocalFooter hospitalName={this.state.locationName} theme={theme} />
              </div>
            )
        }
      </div>
    );
  }
}

export default PainelCentroCirurgico;
